import React from 'react';

const VARIANTS = {
  info: {
    background: 'rgba(211,228,255,0.50)',
    border: 'rgba(0,80,142,0.20)',
    color: '#00508e',
    icon: 'info',
  },
  success: {
    background: 'rgba(163,243,145,0.25)',
    border: 'rgba(33,109,28,0.22)',
    color: '#216d1c',
    icon: 'check_circle',
  },
  warning: {
    background: 'rgba(255,220,196,0.40)',
    border: 'rgba(109,69,36,0.22)',
    color: '#6d4524',
    icon: 'warning',
  },
  error: {
    background: '#ffdad6',
    border: 'rgba(186,26,26,0.22)',
    color: '#93000a',
    icon: 'error',
  },
};

export default function Alert({
  children,
  variant = 'info',
  title,
  icon,
  onClose,
  className = '',
}) {
  const cfg = VARIANTS[variant] || VARIANTS.info;

  return (
    <div
      className={className}
      style={{
        display: 'flex', alignItems: 'flex-start', gap: 10,
        padding: '12px 16px',
        borderRadius: 12,
        background: cfg.background,
        border: `1px solid ${cfg.border}`,
      }}
      role="alert"
    >
      <span
        className="material-symbols-outlined"
        style={{
          fontSize: 18, color: cfg.color, flexShrink: 0, marginTop: 1,
          fontVariationSettings: "'FILL' 1",
        }}
      >
        {icon || cfg.icon}
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && (
          <div style={{ fontSize: 13, fontWeight: 600, color: cfg.color, marginBottom: 2, fontFamily: "'Space Grotesk', sans-serif" }}>
            {title}
          </div>
        )}
        <div style={{ fontSize: 13, color: cfg.color, fontFamily: "'Noto Sans JP', sans-serif" }}>
          {children}
        </div>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            flexShrink: 0, padding: 4, borderRadius: 6,
            border: 'none', background: 'transparent',
            cursor: 'pointer', color: cfg.color,
            transition: 'background 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.06)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
          aria-label="閉じる"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>close</span>
        </button>
      )}
    </div>
  );
}
